import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReportState, RunReportParams } from "src/types/report.types";

const initialState: ReportState = {
  runReport: {
    loading: false,
    data: null,
    error: null,
  },
};

const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
    runReportRequest: (state, action: PayloadAction<RunReportParams>) => {
      state.runReport.loading = true;
      state.runReport.error = null;
    },
    runReportSuccess: (state, action: PayloadAction<any>) => {
      state.runReport.loading = false;
      state.runReport.data = action.payload;
      state.runReport.error = null;
    },
    runReportError: (state, action: PayloadAction<string>) => {
      state.runReport.loading = false;
      state.runReport.error = action.payload;
    },
    resetRunReport: (state) => {
      state.runReport = { loading: false, data: null, error: null };
    },
  },
});

export const {
  runReportRequest,
  runReportSuccess,
  runReportError,
  resetRunReport,
} = reportSlice.actions;

export default reportSlice.reducer;
